module.exports = "/assets/site/images/rabi_veronika.jpg?ede44b1eb228c66dfcc406c2cf016c56";